import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import { GroupTypeDocument } from 'shell/models/type-doc-group';

// export const typeDocuments = Object.freeze([
//   {
//     id: 'CA',
//     value: 'Certificati ANPR',
//   },
//   {
//     id: 'CS',
//     value: 'Certificati Storici',
//   },
//   {
//     id: 'AT',
//     value: 'Attestazioni',
//   },
//   {
//     id: 'AU',
//     value: 'Autentiche',
//   },
//   {
//     id: 'CE',
//     value: 'Certificati elettorali',
//   },
//   {
//     id: 'CL',
//     value: 'Certificati Leva',
//   },
//   {
//     id: 'DS',
//     value: 'Dichiarazioni sostitutive',
//   },
//   {
//     id: 'CO',
//     value: 'Contestual',
//   },
// ]);

interface GroupTypeDocumentListProps {
  disabled?: boolean;
  value: string;
  required?: boolean;
  onChange: (event: SelectChangeEvent<string>, item?: ItemVM) => void;
  error?: boolean;
  label?: string;
}

const GroupTypeDocumentListComponent = ({
  disabled,
  onChange,
  value,
  required,
  label = 'Tipo Documento',
  error,
}: GroupTypeDocumentListProps): React.ReactElement => {
  const [groupTypeDocument] = useHttpFetch<HttpResponseList<GroupTypeDocument>, Array<ItemVM>>(
    `${__CERTIFICATION_API_URL__}/certificazione/tipi-documento/raggruppamento`,
    {
      onBootstrap: true,
      initialData: [],
      transformer: (response) => {
        return response.data.payload?.list?.map((element) => ({
          id: element.key?.tipoDocumento,
          value: `${element.key?.tipoDocumento} - ${element.descrizioneTipoDocumento}`,
        })) as Array<ItemVM>;
      },
    }
  );

  const list = (groupTypeDocument.data as Array<ItemVM>) || [];

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="type-doc-label">
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId="type-doc-label"
        id="type-doc"
        name="type-doc"
        value={value}
        label={required ? 'Tipo documento *' : 'Tipo documento'}
        onChange={(event) => {
          const item = list.find((element) => element.id === event.target.value);

          onChange(event, item);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((type: ItemVM) => (
          <MenuItem key={type.id} value={type.id}>
            {type.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

GroupTypeDocumentListComponent.displayName = 'List group type document component';

const GroupTypeDocumentList = memo(GroupTypeDocumentListComponent);

export default GroupTypeDocumentList as typeof GroupTypeDocumentListComponent;
